import { isMobile } from 'utils';
import jQuery from 'jquery';

export default () => {
  function heightToContent($textarea) {
    const scrollHeight = $textarea[0].scrollHeight - 24;
    console.log($textarea.height(), scrollHeight, $textarea.data('height'));

    if (scrollHeight > $textarea.height()) {
      $textarea.height(scrollHeight);
    } else {
      if (scrollHeight > $textarea.data('height')) {
        $textarea.height(scrollHeight);
      } else {
        $textarea.height($textarea.data('height'));
      }
    }
  }

  if (!isMobile) {
    jQuery('textarea.flexible').each(function () {
      const $textarea = jQuery(this);
      $textarea.data('height', $textarea.height());
    });

    jQuery('textarea.flexible').focus(function () {
      heightToContent(jQuery(this));
    });

    jQuery('textarea.flexible').keypress(function () {
      heightToContent(jQuery(this));
    });

    jQuery('textarea.flexible').blur(function () {
      const $textarea = $(this);
      if ($textarea.height() > $textarea.data('height')) {
        $textarea.height($textarea.data('height'));
      }
    });

    jQuery('.file-upload input[type=file]').change(function(){
      let filename = jQuery(this).val().replace(/.*\\/, '');
      jQuery('.file-upload span').text(filename);
    });

    // Placeholder animation
    jQuery('.ph-animate').each(function () {
      let placeholder = $(this).attr('placeholder');
      jQuery(this).after('<div class="placeholder">' + placeholder + '</div>');
      jQuery(this).attr('placeholder', null);
    });

    jQuery('.ph-animate').focus(function () {
      const $placeholder = jQuery(this).next();

      setTimeout(function () {
        $placeholder.addClass('focus').removeClass('blur');
      }, 300);

    });

    jQuery('.ph-animate').blur(function () {
      const value = jQuery(this).val();
      const $placeholder = jQuery(this).next();
      if (value === '') {
        $placeholder.removeClass('focus').removeClass('blur');
      } else {
        $placeholder.removeClass('focus').addClass('blur');
      }
    });
  }
}


// WEBPACK FOOTER //
// ./wordpress/wp-content/themes/foach/js/modules/forms.js